import { ArrowLeft, ArrowRight, ArrowUpLeft, ArrowUpRight } from 'lucide-react';
import { useI18n } from '../i18n';

/** Outbound / “open” affordance — flips for RTL */
export function ExternalArrow({
  size = 14,
  className,
  style,
}: {
  size?: number;
  className?: string;
  style?: React.CSSProperties;
}) {
  const { dir } = useI18n();
  const Icon = dir === 'rtl' ? ArrowUpLeft : ArrowUpRight;
  return <Icon size={size} className={className} style={style} aria-hidden />;
}

/** Back navigation arrow — flips for RTL */
export function BackArrow({
  size = 14,
  className,
  style,
}: {
  size?: number;
  className?: string;
  style?: React.CSSProperties;
}) {
  const { dir } = useI18n();
  const Icon = dir === 'rtl' ? ArrowRight : ArrowLeft;
  return <Icon size={size} className={className} style={style} aria-hidden />;
}
